import { genericPage, getServerSidePropsHelper } from 'components/corporatiu/Page';
import { useRouter } from 'next/router';

const basePath = ['web', process.env.FOLDER_LAYOUTS_CORPORATIU, 'visita-les-instalacions'];

const Pagina = (props) => {
    const router = useRouter();
    return genericPage(props, router, basePath);
};

export async function getServerSideProps(context) {
    const { slug } = context.query;
    let path = [...basePath, slug];
    const options = {
        slugs: path
    };

    return getServerSidePropsHelper(context, options);
}

export default Pagina;
